<template>
  <form @submit.prevent="submit">
    <div class="form-group">
      <label>Parent category</label>
      <tree-select 
        v-model="model.parent_id" 
        :options="options"/>
    </div>
    <field
      :field="fields.get('title')"
      :model="model"
      :errors="errors"
      layout="vertical"/>

    <fields
      :errors="errors"
      :fields="fields.except('title', 'company_id', 'parent_id')"
      :model="model"
      layout="vertical"/>

    <div class="form-group">
      <label for="primary_company">Primary Company</label>
      <select
        id="primary_company"
        v-model="model.company_id"
        class="form-control"
      >
        <option value="">Select primary company</option>
        <option
          v-for="company in companies"
          :value="company.id"
        >
          {{ company.title }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        Save
      </b-button>
      <b-button
        type="button"
        variant="light"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import TreeMixin from '../mixins/TreeMixin'
import Proxy from './Proxy';

export default {
  name: 'CategoriesForm',

  components: {
    Layout,
  },

  mixins: [ResourceFormMixin, TreeMixin],

  data() {
    return {
      category_id: this.$route.params.id,
      companies: []
    }
  },

  created() {
    this.loadForm(Proxy);

    this.$http.get(`/companies/category/${this.category_id}`)
      .then(response => {
        this.companies = response.data
      }).then(() => {
        if(this.model.company_id === null)
          this.model.company_id = ''
    })

  },

  methods: {
    submit() {
      this.save(Proxy)
        .then(() => {
          this.$toast.success('Category was saved successfully');
        });
    },
  },

};
</script>
